import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";

function BuildLink({
  parent_type: parentType,
  reference_record_id: parentId,
  reference_record_line_item_id: id,
  reference_number: referenceNumber,
  pushHistory
}) {
  if (!parentType) {
    return <td>{referenceNumber}</td>;
  }

  let link;
  if (parentType === "rma") {
    link = `/rmas/${id}`;
  } else if (parentType === "mistake_shipment") {
    link = `/mistake-shipments/${id}`;
  } else {
    link = `/${parentType.replaceAll("_", "-")}/${parentId}`;
  }
  const handleClick = ev => {
    ev.stopPropagation();
    pushHistory(link);
  };

  return (
    <td>
      <a onClick={handleClick}>{referenceNumber}</a>
    </td>
  );
}

export default connect(undefined, dispatch => ({
  pushHistory: url => dispatch(push(url))
}))(BuildLink);

BuildLink.propTypes = {
  parent_type: PropTypes.string,
  pushHistory: PropTypes.func,
  reference_number: PropTypes.string,
  reference_record_line_item_id: PropTypes.string,
  reference_record_id: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Search/BuildLink.jsx